export default "__VITE_ASSET__DGCuODLc__"